export const translationNL = {
  translation: {
    navBar: {
      title: {
        calendar: "Kies data",
        accommodation: "Accommodatie",
        extras: "Extra's",
        summary: "Overzicht",
        details: "Gegevens",
        payment: "Betaling",
        success: "Bevestiging",
      },
    },
    cart: {
      title: {
        calendar: "Naar accommodaties",
        accommodation: "Door naar extra's",
        extras: "Controleer je boeking",
        summary: "Vul je gegevens in",
        details: "Door naar betaling",
        payment: "Boeking afronden",
      },
      selectArrivalDate: "Kies een aankomstdatum",
      selectDepartureDate: "Kies een vertrekdatum",
      priceFrom: "Vanaf",
    },
    weekDays: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    months: [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mrt",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          description:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            { src: "see_the_top_hub.jpg", alt: "Bekijk de bovenste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Binnenkant bovenste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Bekijk de onderste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Binnenkant onderste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Ontspan in je kingsize-bed",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, je kunt rechtop zitten in bed",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Speel je muziek af via Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Loop naar de douches in onze kimono's",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Fris je op onder de regendouche",
            },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            { src: "hair_&_makeup_area.jpg", alt: "Haar- & make-upruimte" },
          ],
        },
        howManyTravellers: {
          title: "Hoeveel reizigers?",
          content:
            "Al onze accommodaties zijn uitgerust met heerlijke bedden, sfeerverlichting en moderne techniek. De vraag is: hoe wil je verblijven? <br /><br />Onze Hubs zijn ideaal voor soloreizigers, koppels of vrienden die privacy en een knusse sfeer waarderen.<br /><br />Selecteer 1 tot 4 reizigers om de prijswijziging te zien.",
        },
        addAnotherAccomodation: {
          title: "Voeg Hub toe",
          hub: {
            title: "Hub",
            description:
              "Privé Hub met kingsize bed – perfect voor één of twee reizigers.",
          },
        },
      },
      CPH: {
        tags: ["Sauna op locatie"],
        hub: {
          title: "Hub",
          excerpt:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          description:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            { src: "see_the_top_hub.jpg", alt: "Bekijk de bovenste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Binnenkant bovenste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Bekijk de onderste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Binnenkant onderste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Ontspan in je kingsize bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Loop naar de douches in onze kimono's",
            },
            { src: "hallway.jpg", alt: "Gang" },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Heerlijk zweten in onze sauna",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Zelfde grootte als een Hub, maar verdeeld in 2 eenpersoonsmatrassen met aparte dekens en een tussenschot. Ideaal voor 2 personen die hun eigen plekje willen. Geweldig voor vrienden of broers/zussen.",
          description:
            "Zelfde grootte als een Hub, maar verdeeld in 2 eenpersoonsmatrassen met aparte dekens en een tussenschot. Ideaal voor 2 personen die hun eigen plekje willen. Geweldig voor vrienden of broers/zussen.",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Binnenkant bovenste Twin Hub",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Binnenkant onderste Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 eenpersoonsmatrassen met een tussenschot",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Heerlijk zweten in onze sauna",
            },
          ],
        },
        room: {
          title: "Quad Room",
          excerpt:
            "Meer ruimte nodig? De Quad Room biedt plaats aan maximaal 4 reizigers. Ideaal voor vrienden of families. Met eigen badkamer. Ook geschikt voor minder mobiele gasten.",
          description:
            "Meer ruimte nodig? De Quad Room biedt plaats aan maximaal 4 reizigers. Ideaal voor vrienden of families. Met eigen badkamer. Ook geschikt voor minder mobiele gasten.",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad Room met 4 stapelbedden",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad Room met een tweepersoonsbed en 2 stapelbedden",
            },
            { src: "private_bathroom.jpg", alt: "Eigen badkamer" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Fris op onder de regendouche",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Heerlijk zweten in onze sauna",
            },
          ],
        },
        howManyTravellers: {
          title: "Hoeveel reizigers?",
          content:
            'Al onze accommodaties bieden comfortabele bedden, sfeerverlichting en een vleugje techniek. De enige vraag is: hoe verblijf je het liefst? <ul className="list-disc p-4"><li>Alleen of als koppel onderweg en zin in privacy? → Kies een Hub.</li><li>Samen reizen, maar liever aparte bedden (vrienden/collega\'s)? → Een Twin Hub is perfect.</li><li>Op zoek naar een ruimere kamer met eigen badkamer? → Kies de Quad Room.</li></ul>Waar je ook voor kiest, je zult heerlijk slapen.<br />Kies 1 of 2 gasten om de prijs te zien.',
        },
        addAnotherAccomodation: {
          title: "Nog een accommodatie toevoegen",
          hub: {
            title: "Hub",
            description:
              "Privé Hub met kingsize bed – perfect voor één of twee reizigers.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Privé Hub met twee aparte bedden en een tussenschot – ideaal voor vrienden.",
          },
          room: {
            title: "Room",
            description:
              "Privékamer met stapelbedden en eigen badkamer – perfect voor maximaal vier personen.",
          },
        },
      },
      RKV: {
        tags: ["Hot tub op locatie"],
        hub: {
          title: "Hub",
          excerpt:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          description:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            { src: "see_the_top_hub.jpg", alt: "Bekijk de bovenste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Binnenkant bovenste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Bekijk de onderste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Binnenkant onderste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Ontspan in je kingsize bed",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, je kunt rechtop zitten in bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Loop naar de douches in onze kimono's",
            },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Ontspan in onze hot tub op het dak",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Zelfde grootte als een Hub, maar verdeeld in 2 eenpersoonsmatrassen met aparte dekens en een tussenschot. Ideaal voor 2 personen die hun eigen plekje willen. Geweldig voor vrienden of broers/zussen.",
          description:
            "Zelfde grootte als een Hub, maar verdeeld in 2 eenpersoonsmatrassen met aparte dekens en een tussenschot. Ideaal voor 2 personen die hun eigen plekje willen. Geweldig voor vrienden of broers/zussen.",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Binnenkant bovenste Twin Hub",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Binnenkant onderste Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 eenpersoonsmatrassen met een tussenschot",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Loop naar de douches in onze kimono's",
            },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Ontspan in onze hot tub op het dak",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Privé Hub met kingsize bed en groot tv-scherm.",
          description:
            "Deze compacte kamer voor maximaal 2 reizigers heeft een kingsize bed en een grote televisie. Ideaal voor binge-watching direct vanuit je bed.",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Ontspan in je kingsize bed",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Grote tv voor je favoriete series",
            },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Ontspan in onze hot tub op het dak",
            },
          ],
        },
        howManyTravellers: {
          title: "Hoeveel reizigers?",
          content:
            'Al onze accommodaties bieden comfortabele bedden, sfeerverlichting en een vleugje techniek. De enige vraag is: hoe verblijf je het liefst? <ul className="list-disc p-4"><li>Alleen of als koppel onderweg en zin in privacy? → Kies een Hub.</li><li>Samen reizen, maar liever aparte bedden (vrienden/collega\'s)? → Een Twin Hub is perfect.</li><li>Op zoek naar een meer traditionele kamer met een grote tv (gedeelde badkamer)? → Kies een Movie Hub.</li></ul>Waar je ook voor kiest, je zult heerlijk slapen.<br />Kies 1 of 2 gasten om de prijs te zien.',
        },
        addAnotherAccomodation: {
          title: "Nog een accommodatie toevoegen",
          hub: {
            title: "Hub",
            description:
              "Privé Hub met kingsize bed – perfect voor één of twee reizigers.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Privé Hub met 2 aparte bedden en een tussenschot – ideaal voor vrienden.",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Compacte privékamer met kingsize bed en tv – perfect voor maximaal twee personen.",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          description:
            "Je eigen privé Hub voor maximaal 2 reizigers met een kingsize bed. Perfect voor soloreizigers, vrienden of koppels die houden van comfort.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            { src: "see_the_top_hub.jpg", alt: "Bekijk de bovenste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Binnenkant bovenste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Bekijk de onderste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Binnenkant onderste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Ontspan in je kingsize bed",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, je kunt rechtop zitten in bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Loop naar de douches in onze kimono's",
            },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Fris je op onder de regendouche",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Zelfde grootte als een Hub, maar verdeeld in 2 eenpersoonsmatrassen met aparte dekens en een tussenschot. Ideaal voor 2 personen die hun eigen plekje willen. Geweldig voor vrienden of broers/zussen.",
          description:
            "Zelfde grootte als een Hub, maar verdeeld in 2 eenpersoonsmatrassen met aparte dekens en een tussenschot. Ideaal voor 2 personen die hun eigen plekje willen. Geweldig voor vrienden of broers/zussen.",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Een Hub is een L-vormige unit",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Binnenkant onderste Twin Hub",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Ontspan in je kingsize bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Loop naar de douches in onze kimono's",
            },
            { src: "women_s_bathroom.jpg", alt: "Damesbadkamer" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Fris je op onder de regendouche",
            },
            { src: "men_s_bathroom.jpg", alt: "Herenbadkamer" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals producten",
            },
          ],
        },
        howManyTravellers: {
          title: "Hoeveel reizigers?",
          content:
            'Al onze accommodaties bieden comfortabele bedden, sfeerverlichting en een vleugje techniek. De enige vraag is: hoe verblijf je het liefst? <ul className="list-disc p-4"><li>Alleen of als koppel onderweg en zin in privacy? → Kies een Hub.</li><li>Samen reizen, maar liever aparte bedden (vrienden/collega\'s)? → Een Twin Hub is perfect.</li></ul>Waar je ook voor kiest, je zult heerlijk slapen.<br />Kies 1 of 2 gasten om de prijs te zien.',
        },
        addAnotherAccomodation: {
          title: "Nog een accommodatie toevoegen",
          hub: {
            title: "Hub",
            description:
              "Privé Hub met kingsize bed – perfect voor één of twee reizigers.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Privé Hub met twee aparte bedden en een tussenschot – ideaal voor vrienden.",
          },
        },
      },
      tags: {
        hub: [
          "Privé Hub voor 1-2 personen",
          "1 kingsize bed",
          "Gedeelde badkamers",
          "Rituals producten",
          "Handdoeken",
          "Kimono's",
        ],
        twinHub: [
          "Privé Hub voor 2 personen",
          "2 eenpersoonsmatrassen met tussenschot",
          "Gedeelde badkamers",
          "Rituals producten",
          "Handdoeken",
          "Kimono's",
        ],
        room: [
          "20m² kamer voor 1-4 personen",
          "4 stapelbedden of 2 stapelbedden & tweepersoonsbed",
          "Eigen badkamer",
          "Rituals producten",
          "Handdoeken",
          "Kimono's",
          "Toegankelijk voor rolstoelen",
        ],
        movieHub: [
          "Privé Hub voor 1-2 personen",
          "1 kingsize bed",
          "Gedeelde badkamers",
          "Rituals producten",
          "Handdoeken",
          "Kimono's",
          "Televisie",
        ],
      },
      faq: {
        hub: [
          {
            q: "Bovenste of onderste Hub? Kan ik kiezen?",
            a: "Jazeker. Een Hub is je eigen privé Hub, L-vormig en ontworpen voor 2 personen. Hubs zijn gestapeld in paren: één boven en één onder. Bij het inchecken beslis je met je CityHost of je liever omhoog klimt of erin duikt.",
          },
          {
            q: "Vertel me meer over deze Hub.",
            a: "Je Hub van 6 m² is uitgerust met slimme opbergruimte, stopcontacten en WiFi. De bedden zijn al voor je opgemaakt. Met de CityHub app kun je de verlichting aanpassen aan je stemming. Inclusief Bluetooth-muziekstreaming.",
          },
          {
            q: "Is er airconditioning in de Hub?",
            a: "Ja, je Hub is aangesloten op een centraal airconditioningsysteem, ingesteld op de meest comfortabele temperatuur voor de gemiddelde reiziger.",
          },
          {
            q: "Wat kan ik verwachten van de badkamers?",
            a: "Best luxe. Gedeeld, maar gescheiden voor mannen en vrouwen, voorzien van regendouches en gratis Rituals producten. We houden ze de hele dag door super schoon.",
          },
          {
            q: "Moet ik zelf handdoeken meenemen?",
            a: "We hebben alles voor je klaarliggen. Handdoeken, Rituals zeep, shampoo, haardrogers en ja, zelfs een strijkijzer. Heb je al gehoord van onze speciale CityHub kimono's? Super handig voor de wandeling naar de douche. Neem wel je eigen slippers mee.",
          },
          {
            q: "Kan ik met kinderen komen?",
            a: "We houden van kinderen, echt waar. Helaas zijn onze gedeelde faciliteiten niet geschikt voor baby's of peuters onder de 6 jaar. Houd er rekening mee dat een Hub plaats biedt aan maximaal 2 personen, inclusief kinderen.",
          },
        ],
        twinHub: [
          {
            q: "Bovenste of onderste Hub? Kan ik kiezen?",
            a: "Jazeker. Een Hub is je eigen privé Hub, L-vormig en ontworpen voor 2 personen. Hubs zijn gestapeld in paren: één boven en één onder. Bij het inchecken beslis je met je CityHost of je liever omhoog klimt of erin duikt.",
          },
          {
            q: "Vertel me meer over deze Hub.",
            a: "Je Hub van 6 m² is uitgerust met slimme opbergruimte, stopcontacten en WiFi. De bedden zijn al voor je opgemaakt. Met de CityHub app kun je de verlichting aanpassen aan je stemming. Inclusief Bluetooth-muziekstreaming.",
          },
          {
            q: "Is er airconditioning in de Hub?",
            a: "Ja, je Hub is aangesloten op een centraal airconditioningsysteem, ingesteld op de meest comfortabele temperatuur voor de gemiddelde reiziger.",
          },
          {
            q: "Wat kan ik verwachten van de badkamers?",
            a: "Best luxe. Gedeeld, maar gescheiden voor mannen en vrouwen, voorzien van regendouches en gratis Rituals producten. We houden ze de hele dag door super schoon.",
          },
          {
            q: "Moet ik zelf handdoeken meenemen?",
            a: "We hebben alles voor je klaarliggen. Handdoeken, Rituals zeep, shampoo, haardrogers en ja, zelfs een strijkijzer. Heb je al gehoord van onze speciale CityHub kimono's? Super handig voor de wandeling naar de douche. Neem wel je eigen slippers mee.",
          },
          {
            q: "Kan ik met kinderen komen?",
            a: "We houden van kinderen, echt waar. Helaas zijn onze gedeelde faciliteiten niet geschikt voor baby's of peuters onder de 6 jaar. Houd er rekening mee dat een Hub plaats biedt aan maximaal 2 personen, inclusief kinderen.",
          },
        ],
        room: [
          {
            q: "Vertel me meer over deze Quad room.",
            a: "Je Quad room heeft een eigen badkamer en is uitgerust met stopcontacten en WiFi. De bedden zijn al voor je opgemaakt. Met de CityHub app kun je de verlichting aanpassen aan je stemming. Inclusief Bluetooth-muziekstreaming.",
          },
          {
            q: "Is er airconditioning in de kamer?",
            a: "Ja, je kamer is aangesloten op een centraal airconditioningsysteem, ingesteld op de meest comfortabele temperatuur voor de gemiddelde reiziger.",
          },
          {
            q: "Moet ik zelf handdoeken meenemen?",
            a: "We hebben alles voor je klaarliggen. Handdoeken, Rituals zeep, shampoo, haardrogers en ja, zelfs een strijkijzer. Heb je al gehoord van onze speciale CityHub kimono's? Super handig voor de wandeling naar de douche. Neem wel je eigen slippers mee.",
          },
          {
            q: "Kan ik met kinderen komen?",
            a: "We houden van kinderen, echt waar. Helaas zijn onze gedeelde faciliteiten niet geschikt voor baby's of hele jonge kinderen onder de 6 jaar. Let op: één Quad Room is geschikt voor maximaal 4 personen. Dit is inclusief kinderen.",
          },
        ],
        movieHub: [
          {
            q: "Vertel me meer over deze Movie Hub.",
            a: "Je Movie Hub is uitgerust met slimme opbergruimte, stopcontacten, WiFi en een grote televisie. De bedden zijn al voor je opgemaakt. Met de CityHub app kun je de verlichting aanpassen aan je stemming. Inclusief Bluetooth-muziekstreaming.",
          },
          {
            q: "Is er airconditioning in de Movie Hub?",
            a: "Ja, je Movie Hub is aangesloten op een centraal airconditioningsysteem, ingesteld op de meest comfortabele temperatuur voor de gemiddelde reiziger.",
          },
          {
            q: "Wat kan ik verwachten van de badkamers?",
            a: "Best luxe. Gedeeld, maar gescheiden voor mannen en vrouwen, voorzien van regendouches en gratis Rituals producten. We houden ze de hele dag door super schoon.",
          },
          {
            q: "Moet ik zelf handdoeken meenemen?",
            a: "We hebben alles voor je klaarliggen. Handdoeken, Rituals zeep, shampoo, haardrogers en ja, zelfs een strijkijzer. Heb je al gehoord van onze speciale CityHub kimono's? Super handig voor de wandeling naar de douche. Neem wel je eigen slippers mee.",
          },
          {
            q: "Kan ik met kinderen komen?",
            a: "We houden van kinderen, echt waar. Helaas zijn onze gedeelde faciliteiten niet geschikt voor baby's of peuters onder de 6 jaar. Houd er rekening mee dat een Hub plaats biedt aan maximaal 2 personen, inclusief kinderen.",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Kies stad",
        button: { label: "Kies stad" },
      },
      selectCulture: {
        title: "Taal & valuta",
        button: { label: "Wijzigingen opslaan" },
      },
      uspBar: {
        title: "Laagsteprijsgarantie",
        content:
          "We garanderen je dat je bij een boeking via onze website altijd de best mogelijke prijs krijgt.",
      },
    },
    component: {
      uspBar: {
        title: "Laagsteprijsgarantie",
      },
    },
    scenes: {
      traveller_one: "Reiziger",
      traveller_other: "Reizigers",
      night_one: "Nacht",
      night_other: "Nachten",
      selectHotel: {
        chooseCity: "Laten we samen boeken, kies je stad",
      },
      accommodation: {
        pricePerNight: "Prijs per nacht",
        pricePerNightInclVat: "Prijs per nacht (incl. BTW)",
        remove: "Verwijder",
        directBookingDiscount: "Directboeking korting",
        notAvailable: "niet beschikbaar",
        unavailable: "Niet beschikbaar",
        noMoreRoomsAvailable: "Boek nu · laatste Hub",
        addAnotherRoom: "Voeg hub toe",
        addAnotherHub: "Nog een Hub toevoegen",
        howManyTravellers: "Hoeveel reizigers?",
        questions: "FAQs",
        moreTags_one: "meer tag",
        moreTags_other: "meer tags",
        more_info: "meer info",
        show_more: "Meer informatie",
        show_less: "Minder informatie",
        selected: "geselecteerd",
        select: "Selecteren",
        price_from: "Vanaf",
        not_available: "Niet beschikbaar op deze datum",
        add: "Toevoegen",
        how_many_rooms: "Hoeveel {{name}}s?",
        room_category_rates: {
          title: "Tarieven",
        }
      },
      calendar: {
        startNotice: "{{hotelName}} opent haar deuren op {{startDate}}",
      },
      extras: {
        perPersonPerNight: "per persoon, per nacht",
        add: "Toevoegen",
        remove: "Verwijder",
        moreInfo: "Meer info",
      },
      summary: {
        perNight: "/ nacht",
        checkIn: "CHECK-IN",
        checkOut: "CHECK-OUT",
        rate: "Tarief:",
        discount: "Korting:",
        from: "Van",
        before: "Vóór",
        total: "Totaal",
        incCityTax: "Toeristenbelasting",
        incVat: "Incl. BTW",
        incVatRooms: "Incl. BTW kamers",
        incVatProducts: "Incl. BTW producten",
        directBookingDiscount: "Directboeking korting",
        voucher: "Voucher",
        addVoucher: "Voucher toevoegen",
        voucherInvalid: "Deze vouchercode is niet correct",
        voucherNotApplicable: "Deze voucher is niet geldig voor het gekozen tarief",
      },
      details: {
        firstName: "Voornaam",
        firstNameRequired: "Voornaam is verplicht",
        lastName: "Achternaam",
        lastNameRequired: "Achternaam is verplicht",
        email: "E-mailadres",
        emailRequired: "E-mailadres is verplicht",
        emailInvalid:
          "E-mail is verplicht en moet een @ en ten minste één punt bevatten",
        phoneMin: "Telefoonnummer moet minimaal 9 cijfers bevatten",
        phoneInvalid: "Telefoonnummer moet numeriek zijn",
        countryRequired: "Land is een verplicht veld",
        phone: "Telefoonnummer",
        country: "Land",
        selectCountry: "Selecteer je land",
        specialRequests: "Speciale verzoeken",
        terms:
          "Ik ga akkoord met de <firstLink>Algemene Voorwaarden</firstLink> en het <secondLink>Privacybeleid</secondLink> van de accommodatie.",
        marketingEmails: "Ik wil graag af en toe marketingupdates ontvangen.",
        createReservation: "Reservering maken",
        finishPaymentAtKiosk: "Rond je betaling af bij onze kiosk.",
        creatingReservation: "Je reservering wordt aangemaakt...",
        reservationCreated: "Reservering gemaakt!",
        somethingWentWrong: "Er is iets misgegaan, probeer het opnieuw.",
      },
      payment: {
        paymentMethods: "Betaalmethoden",
        paymentMethodsDescription:
          "Nog één laatste stap – rond je betaling hieronder veilig af. We gebruiken versleutelde betaalmethoden om je gegevens bij elke stap te beschermen. Zodra je betaling is bevestigd, ontvang je je bevestigingsmail.",
        authorizeCreditCard: "Autoriseer je creditcard",
        cardChargeInfo: "Je kaart wordt 48 uur voor de dag van aankomst belast",
        securedWithMews: "Beveiligd met Mews Payments via PCI Proxy",
        payWithCreditCard: "Betaal met creditcard",
        payDirectly: "Betaal direct",
        onlyVisaAndMastercardSupported:
          "Alleen Visa en MasterCard worden ondersteund",
        nameOnCreditCard: "Naam op creditcard",
        cardNumber: "Kaartnummer",
        expirationDate: "Vervaldatum",
        expirationDateRequired: "Vervaldatum is verplicht",
        yearCanNotBeInThePast: "Jaar mag niet in het verleden liggen",
        yearCanNotBeMoreThan5YearsInTheFuture:
          "Jaar mag niet meer dan 5 jaar in de toekomst liggen",
        monthCanNotBeInThePast: "Maand mag niet in het verleden liggen",
        monthCanNotBeBiggerThan12: "Maand mag niet groter zijn dan 12",
        shouldBeAMonthAndAYear: "Moet een maand en een jaar zijn MM/JJJJ",
        validateCard: "Kaart valideren",
        createReservation: "Reservering maken",
        nameIsRequired: "Naam is verplicht",
        cardNumberIsRequired: "Kaartnummer is verplicht",
        invalidCardNumber: "Ongeldig kaartnummer",
        cvcIsRequired: "CVC is verplicht",
        invalidCvc: "Ongeldige CVC",
        somethingWentWrong: "Er is iets misgegaan. Probeer het later opnieuw.",
        somethingWentWrong4501:
          "Er is iets misgegaan (4501). Probeer het later opnieuw.",
        creatingReservation: "Je reservering wordt aangemaakt...",
        reservationCreated: "Reservering gemaakt!",
        finishPayment: "Je betaling wordt afgerond...",
        creditcardNotAuthorizable: "Creditcard niet autoriseerbaar",
      },
      success: {
        bookingConfirmed: "Boeking bevestigd!",
        bookingConfirmedDescription:
          "Je verblijf bij {{hotelName}} is geregeld. <br/>Check-in vanaf 15:00 uur. Tot snel 👋",
        startChatting: "Begin met chatten",
        viewBookingDetails: "Bekijk boekingsgegevens",
        bookingDetails: "Boekingsgegevens",
        whatsNext: "Wat nu?",
        connectWithHost:
          "Maak contact met je CityHost, jouw persoonlijke 24/7 contactpersoon voor tips, routes en lokale geheimen.",
        online: "ONLINE",
      },
      pageNotFound: {
        message: "Oeps! <br />We kunnen de pagina die je zoekt niet vinden.",
        linkText: "Kies je hotel om te beginnen",
      },
      redirectHotel: {
        message: "Je boeking wordt geladen…",
      },
      redirectPayment: {
        error4602: "[fout" + ":4602] Geen reservering gevonden",
        noPaymentsFound: "Geen betalingen gevonden",
        paymentSuccessful: "Betaling geslaagd",
        paymentFailed: "Betaling mislukt",
        returningToSite: "Terugkeren naar de site...",
        authorizationPending: "Autorisatie in behandeling",
        authorizationPendingMessage:
          "Je reservering is aangemaakt, maar de autorisatie is nog in behandeling.<br /><br />Klik hier om je kaart te autoriseren.",
      },
    },
    form: {
      language: {
        label: "Taal",
        placeholder: "Selecteer taal",
        options: {
          "en-US": "Engels",
          "nl-NL": "Nederlands",
          "de-DE": "Duits",
        },
        validation: { required: "Taal is een verplicht veld" },
      },
      currency: {
        label: "Valuta",
        placeholder: "Selecteer valuta",
        options: {
          EUR: "Euro (€)",
          USD: "US Dollar ($)",
          GBP: "Brits Pond (£)",
          CAD: "Canadese Dollar (C$)",
          DKK: "Deense Kroon (DKK)",
          ISK: "IJslandse Kroon (ISK)",
        },
        validation: { required: "Valuta is een verplicht veld" },
      },
    },
  },
};
